import { getExt } from "shared/utils/getExt"

// Every build target — web, PWA, Electron, Tauri — loads its own bundled
// index.html as the page root, and CRA always copies the whole public/
// folder (including public/beats/*.mp3) alongside it. So a plain relative
// path resolves correctly everywhere with zero platform-specific bridging.
export function getBeatSrc(beat) {
  const ext = getExt(beat.file) ? "" : ".mp3"
  return `${process.env.PUBLIC_URL}/beats/${encodeURIComponent(beat.file + ext)}`
}
